// @flow

export {default} from './middleware';

export type {
    CallInfo,
    CallApi,
    DownloadFile,
    PrintFile,
    UploadFile,
    ApiAction,
    Dispatch,
    Action,
    Types,
    ApiDispatch,
    Type,
    HandleError
} from './typedef';

export {
    TRANSPORT_REQUEST_BODY,
    TRANSPORT_REQUEST_FILE,
    TRANSPORT_REQUEST_PARAMS,
    TRANSPORT_GET_PARAMS,
    CALL_API,
    DOWNLOAD_FILE,
    PRINT_FILE,
    UPLOAD_FILE,
    ApiMethods,
    ConcurrentStrategies,
    OBSOLETE_REQUEST_ERROR
} from './constants';

export {prepareRequestData} from './prepare-request-data';
export {handleErrors} from './handle-errors';
export {getUrl} from './utils/get-url';
export {prepareQueryParams as getParams} from './transport/get-params';
export {request} from './request';

export {callApi} from './call-api';
export {printFile} from './print-file';
export {downloadFile} from './download-file';
export {uploadFile} from './upload-file';
export {responseToPayload} from './response-to-payload';

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./middleware");

require("./constants");

require("./typedef");

require("./prepare-request-data");

require("./handle-errors");

require("./request");

require("./call-api");

require("./download-file");

require("./print-file");

require("./upload-file");

require("./response-to-payload");

require("./utils/get-url");

require("./transport/get-params");
